{
    "Accessibility menu": "menu d'accessibilité",
    "Close": "Fermer",
    "Content adjustments": "Ajustements du Contenu",
    "Navigation adjustments": "Ajustements de Navigation",
    "Text Align": "Text Align",
    "Align Left": "Aligner à Gauche",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Ajuster la Taille de Police",
    "Highlight Title": "Mettre en Évidence le Titre",
    "Highlight Links": "Mettre en Évidence les Liens",
    "Readable Font": "Police Lisible",
    "Colour adjustments": "Ajustements de Couleur",
    "Dark Contrast": "Contraste Sombre",
    "Light Contrast": "Contraste Clair",
    "High Contrast": "Contraste Élevé",
    "High Saturation": "Saturation Élevée",
    "Low Saturation": "Saturation Faible",
    "Monochrome": "Monochrome",
    "Tools": "Outils",
    "Reading Guide": "Guide de Lecture",
    "Big Cursor": "Curseur Agrandi",
    "Increase Font Size": "Augmenter la Taille de Police",
    "Decrease Font Size": "Diminuer la Taille de Police",
    "Letter Spacing": "Espacement des Lettres",
    "Line Height": "Hauteur de Ligne",
    "Font Weight": "Épaisseur de Police",
    "Dyslexia Font": "Police pour Dyslexie",
    "Language": "Langue",
    "Accessibility widget": "Ouvrir le menu d'accessibilité",
    "Accessibility Profiles": "Profils d'Accessibilité",
    "Cognitive Disability": "Handicap Cognitif",
    "Seizure Safe": "Sûr pour l'Épilepsie",
    "Accessibility statement": "Déclaration d'Accessibilité",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Arrêter les Animations",
    "Reset all settings": "Réinitialiser les Paramètres",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
